module.exports = __webpack_public_path__ + "static/gt-ed4b7f77f6c4e5316452bfc7ec7f7acc.svg";